import { HorizontalSafeAreaContainer } from '../../../../components';
import { OrderProductConfirmProductScreen } from '../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return (
    <HorizontalSafeAreaContainer>
      <OrderProductConfirmProductScreen />
    </HorizontalSafeAreaContainer>
  );
}
